import { Recruitment } from "./recruitment";

export class RecruitmentDefaultModel extends Recruitment {}
